import { countries } from "countries-list";

export const COUNTRY_CONFIG = {
  PRIORITY_COUNTRIES: ["US", "CA", "GB", "AU", "DE", "FR"],
  AREA_CODE_SUPPORT: ["US", "CA"],
};

const COUNTRY_FLAGS = {
  // A
  AD: "🇦🇩",
  AE: "🇦🇪",
  AF: "🇦🇫",
  AG: "🇦🇬",
  AI: "🇦🇮",
  AL: "🇦🇱",
  AM: "🇦🇲",
  AO: "🇦🇴",
  AQ: "🇦🇶",
  AR: "🇦🇷",
  AS: "🇦🇸",
  AT: "🇦🇹",
  AU: "🇦🇺",
  AW: "🇦🇼",
  AX: "🇦🇽",
  AZ: "🇦🇿",

  // B
  BA: "🇧🇦",
  BB: "🇧🇧",
  BD: "🇧🇩",
  BE: "🇧🇪",
  BF: "🇧🇫",
  BG: "🇧🇬",
  BH: "🇧🇭",
  BI: "🇧🇮",
  BJ: "🇧🇯",
  BL: "🇧🇱",
  BM: "🇧🇲",
  BN: "🇧🇳",
  BO: "🇧🇴",
  BQ: "🇧🇶",
  BR: "🇧🇷",
  BS: "🇧🇸",
  BT: "🇧🇹",
  BV: "🇧🇻",
  BW: "🇧🇼",
  BY: "🇧🇾",
  BZ: "🇧🇿",

  // C
  CA: "🇨🇦",
  CC: "🇨🇨",
  CD: "🇨🇩",
  CF: "🇨🇫",
  CG: "🇨🇬",
  CH: "🇨🇭",
  CI: "🇨🇮",
  CK: "🇨🇰",
  CL: "🇨🇱",
  CM: "🇨🇲",
  CN: "🇨🇳",
  CO: "🇨🇴",
  CR: "🇨🇷",
  CU: "🇨🇺",
  CV: "🇨🇻",
  CW: "🇨🇼",
  CX: "🇨🇽",
  CY: "🇨🇾",
  CZ: "🇨🇿",

  // D
  DE: "🇩🇪",
  DJ: "🇩🇯",
  DK: "🇩🇰",
  DM: "🇩🇲",
  DO: "🇩🇴",
  DZ: "🇩🇿",

  // E
  EC: "🇪🇨",
  EE: "🇪🇪",
  EG: "🇪🇬",
  EH: "🇪🇭",
  ER: "🇪🇷",
  ES: "🇪🇸",
  ET: "🇪🇹",

  // F
  FI: "🇫🇮",
  FJ: "🇫🇯",
  FK: "🇫🇰",
  FM: "🇫🇲",
  FO: "🇫🇴",
  FR: "🇫🇷",

  // G
  GA: "🇬🇦",
  GB: "🇬🇧",
  GD: "🇬🇩",
  GE: "🇬🇪",
  GF: "🇬🇫",
  GG: "🇬🇬",
  GH: "🇬🇭",
  GI: "🇬🇮",
  GL: "🇬🇱",
  GM: "🇬🇲",
  GN: "🇬🇳",
  GP: "🇬🇵",
  GQ: "🇬🇶",
  GR: "🇬🇷",
  GS: "🇬🇸",
  GT: "🇬🇹",
  GU: "🇬🇺",
  GW: "🇬🇼",
  GY: "🇬🇾",

  // H
  HK: "🇭🇰",
  HM: "🇭🇲",
  HN: "🇭🇳",
  HR: "🇭🇷",
  HT: "🇭🇹",
  HU: "🇭🇺",

  // I
  ID: "🇮🇩",
  IE: "🇮🇪",
  IL: "🇮🇱",
  IM: "🇮🇲",
  IN: "🇮🇳",
  IO: "🇮🇴",
  IQ: "🇮🇶",
  IR: "🇮🇷",
  IS: "🇮🇸",
  IT: "🇮🇹",

  // J
  JE: "🇯🇪",
  JM: "🇯🇲",
  JO: "🇯🇴",
  JP: "🇯🇵",

  // K
  KE: "🇰🇪",
  KG: "🇰🇬",
  KH: "🇰🇭",
  KI: "🇰🇮",
  KM: "🇰🇲",
  KN: "🇰🇳",
  KP: "🇰🇵",
  KR: "🇰🇷",
  KW: "🇰🇼",
  KY: "🇰🇾",
  KZ: "🇰🇿",

  // L
  LA: "🇱🇦",
  LB: "🇱🇧",
  LC: "🇱🇨",
  LI: "🇱🇮",
  LK: "🇱🇰",
  LR: "🇱🇷",
  LS: "🇱🇸",
  LT: "🇱🇹",
  LU: "🇱🇺",
  LV: "🇱🇻",
  LY: "🇱🇾",

  // M
  MA: "🇲🇦",
  MC: "🇲🇨",
  MD: "🇲🇩",
  ME: "🇲🇪",
  MF: "🇲🇫",
  MG: "🇲🇬",
  MH: "🇲🇭",
  MK: "🇲🇰",
  ML: "🇲🇱",
  MM: "🇲🇲",
  MN: "🇲🇳",
  MO: "🇲🇴",
  MP: "🇲🇵",
  MQ: "🇲🇶",
  MR: "🇲🇷",
  MS: "🇲🇸",
  MT: "🇲🇹",
  MU: "🇲🇺",
  MV: "🇲🇻",
  MW: "🇲🇼",
  MX: "🇲🇽",
  MY: "🇲🇾",
  MZ: "🇲🇿",

  // N
  NA: "🇳🇦",
  NC: "🇳🇨",
  NE: "🇳🇪",
  NF: "🇳🇫",
  NG: "🇳🇬",
  NI: "🇳🇮",
  NL: "🇳🇱",
  NO: "🇳🇴",
  NP: "🇳🇵",
  NR: "🇳🇷",
  NU: "🇳🇺",
  NZ: "🇳🇿",

  // O
  OM: "🇴🇲",

  // P
  PA: "🇵🇦",
  PE: "🇵🇪",
  PF: "🇵🇫",
  PG: "🇵🇬",
  PH: "🇵🇭",
  PK: "🇵🇰",
  PL: "🇵🇱",
  PM: "🇵🇲",
  PN: "🇵🇳",
  PR: "🇵🇷",
  PS: "🇵🇸",
  PT: "🇵🇹",
  PW: "🇵🇼",
  PY: "🇵🇾",

  // Q
  QA: "🇶🇦",

  // R
  RE: "🇷🇪",
  RO: "🇷🇴",
  RS: "🇷🇸",
  RU: "🇷🇺",
  RW: "🇷🇼",

  // S
  SA: "🇸🇦",
  SB: "🇸🇧",
  SC: "🇸🇨",
  SD: "🇸🇩",
  SE: "🇸🇪",
  SG: "🇸🇬",
  SH: "🇸🇭",
  SI: "🇸🇮",
  SJ: "🇸🇯",
  SK: "🇸🇰",
  SL: "🇸🇱",
  SM: "🇸🇲",
  SN: "🇸🇳",
  SO: "🇸🇴",
  SR: "🇸🇷",
  SS: "🇸🇸",
  ST: "🇸🇹",
  SV: "🇸🇻",
  SX: "🇸🇽",
  SY: "🇸🇾",
  SZ: "🇸🇿",

  // T
  TC: "🇹🇨",
  TD: "🇹🇩",
  TF: "🇹🇫",
  TG: "🇹🇬",
  TH: "🇹🇭",
  TJ: "🇹🇯",
  TK: "🇹🇰",
  TL: "🇹🇱",
  TM: "🇹🇲",
  TN: "🇹🇳",
  TO: "🇹🇴",
  TR: "🇹🇷",
  TT: "🇹🇹",
  TV: "🇹🇻",
  TW: "🇹🇼",
  TZ: "🇹🇿",

  // U
  UA: "🇺🇦",
  UG: "🇺🇬",
  UM: "🇺🇲",
  US: "🇺🇸",
  UY: "🇺🇾",
  UZ: "🇺🇿",

  // V
  VA: "🇻🇦",
  VC: "🇻🇨",
  VE: "🇻🇪",
  VG: "🇻🇬",
  VI: "🇻🇮",
  VN: "🇻🇳",
  VU: "🇻🇺",

  // W
  WF: "🇼🇫",
  WS: "🇼🇸",

  // Y
  YE: "🇾🇪",
  YT: "🇾🇹",

  // Z
  ZA: "🇿🇦",
  ZM: "🇿🇲",
  ZW: "🇿🇼",

  // Special territories
  AC: "🇦🇨",
  CP: "🇨🇵",
  DG: "🇩🇬",
  EA: "🇪🇦",
  EU: "🇪🇺",
  IC: "🇮🇨",
  TA: "🇹🇦",
  XK: "🇽🇰",
};

export const transformCountryData = (countryCode, countryData) => {
  const flag = COUNTRY_FLAGS[countryCode] || "";

  return {
    code: countryCode.toUpperCase(),
    name: countryData.name,
    flag: flag,
    phoneCode: countryData.phone,
    currency: countryData.currency,
  };
};

const allCountries = Object.entries(countries)
  .map(([code, data]) => transformCountryData(code, data))
  .sort((a, b) => a.name.localeCompare(b.name));

const priorityCountries = COUNTRY_CONFIG.PRIORITY_COUNTRIES.map((code) =>
  allCountries.find((c) => c.code === code)
).filter(Boolean);

const nonPriorityCountries = allCountries.filter(
  (country) => !COUNTRY_CONFIG.PRIORITY_COUNTRIES.includes(country.code)
);

export const sortedCountries = [...priorityCountries, ...nonPriorityCountries];

export const getCountryByCode = (code) => allCountries.find((country) => country.code === code);

export const getCountryFlag = (countryCode) => {
  if (countryCode && COUNTRY_FLAGS && COUNTRY_FLAGS?.[countryCode]) {
    return COUNTRY_FLAGS?.[countryCode];
  } else {
    return "🌍";
  }
};
